import request from "@/utils/request";

// 列表(主数据列表)
export function loadAppConsumerScanCigaretteCaseErrorLogListDataApi(data) {
  return request({
    url: "web/appConsumerScanCigaretteCaseErrorLog/listData",
    method: "post",
    data
  });
}

// 导出(主数据列表)
export function loadAppConsumerScanCigaretteCaseErrorLogExportDataApi(data) {
  return request({
    url: "web/appConsumerScanCigaretteCaseErrorLog/exportData",
    method: "post",
    data
  });
}

// 操作
export function saveOrUpdateAppConsumerScanCigaretteCaseErrorLogApi(data) {
  return request({
    url: "web/appConsumerScanCigaretteCaseErrorLog/saveOrUpdate",
    method: "post",
    data
  });
}

// 查看
export function initAppConsumerScanCigaretteCaseErrorLogApi(data) {
  return request({
    url: "web/appConsumerScanCigaretteCaseErrorLog/init",
    method: "post",
    data
  });
}